import React from 'react';
import { Form } from 'antd';
import moment from 'moment';
import ChoiceDateField from '../../../formComponents/ChoiceDateField';
import { fieldNames } from '../fieldNames';
import SelectField from '../../../formComponents/SelectField';
import { validationRules } from '../../constants';
import useRoomsCounterparties from '../../../../queries/useRoomsCounterparties';
import getName from '../../../../../../helpers/getName';
import { getReplacedString } from '../../../../../../helpers/getReplacedString';
import TextField from '../../../formComponents/TextField';

const FormBlock = ({ form, initialValues }) => {
  const { getFieldDecorator } = form;

  const { data: counterparties, isFetching: isCounterpartiesFetching } =
    useRoomsCounterparties({ staleTime: Infinity });

  const handleFilterOption = (input, option) => {
    const value = getReplacedString(input);

    const counterparty = getReplacedString(option.props.children);

    return counterparty.includes(value);
  };

  return (
    <Form>
      <SelectField
        label="Арендатор"
        name={fieldNames.tenant}
        getFieldDecorator={getFieldDecorator}
        options={{
          initialValue: initialValues?.id,
          rules: [
            validationRules.required('Выберите арендатора из списка', 'number'),
          ],
        }}
        items={counterparties}
        getContent={(item) => item.name || getName(item)}
        selectProps={{
          placeholder: 'Выберите арендатора',
          disabled: isCounterpartiesFetching || Boolean(initialValues?.id),
          showSearch: true,
          filterOption: handleFilterOption,
          hidden: Boolean(initialValues?.id),
        }}
      />
      <TextField
        label="Лицевой счет"
        name={fieldNames.personalAccount}
        getFieldDecorator={getFieldDecorator}
        options={{
          initialValue: initialValues?.account,
          rules: [validationRules.required('Укажите лицевой счет')],
        }}
      />
      <ChoiceDateField
        label="Начало предоставления/потребления услуг"
        name={fieldNames.beginDate}
        getFieldDecorator={getFieldDecorator}
        initialValue={
          initialValues?.accountStartDate
            ? moment(initialValues.accountStartDate)
            : undefined
        }
      />
    </Form>
  );
};

export default FormBlock;
